// ink-component
import React, { ReactNode } from 'react';
import { ThemeProvider } from 'styled-components';
import getGlobalProps from '../../helpers/constants/global-props';
import Text from '../Typography/Text/Text';
import Heading from '../Typography/Heading/Heading';
import Box from '../Box/Box';
import { StyledSection, SectionHeader, SectionBody, SectionAction } from './styles';

export type SectionProps = {
  /** Title */
  title?: ReactNode;
  /** Subtitle */
  subtitle?: ReactNode;
  /** Action */
  action?: ReactNode;
  /** Help footer text */
  footer?: string;
  /** Removes built-in spacing */
  trim?: boolean;

  /** @ignore */
  children?: ReactNode;
};

const globalProps = getGlobalProps({});

/**
 * @purpose Provides additional structure inside blocks
 * @categories layout
 */
function Section(props: SectionProps) {
  const { title, subtitle, action, footer, trim, children } = props;

  return (
    <ThemeProvider
      theme={currentTheme => ({
        ...currentTheme,
        hasActionsOnly: !title && !subtitle,
        trim,
      })}
    >
      <StyledSection {...globalProps} data-testid={props['data-testid']}>
        <SectionHeader>
          {(title || subtitle) && (
            <Box>
              {title && (
                <Heading variant="heading-3" trim>
                  {title}
                </Heading>
              )}
              {subtitle && <Text trim>{subtitle}</Text>}
            </Box>
          )}
          {action && <SectionAction>{action}</SectionAction>}
        </SectionHeader>
        <SectionBody>{children}</SectionBody>
        {footer && <Text>{footer}</Text>}
      </StyledSection>
    </ThemeProvider>
  );
}

Section.defaultProps = {
  title: undefined,
  subtitle: undefined,
  action: undefined,
  footer: undefined,
  trim: false,
};

Section.displayName = 'Section';

export default Section;
